import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { defaultFacets, defaultFacets1, normalizeItems, sortOptions } from '../../config/search';
import { Search, SearchSidebar, SearchContent } from "@civicactions/data-catalog-components";
import config from "../../assets/config.json";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import './search.css'

const SearchTemplate = ({ path, location }) => {
  
  let toggle = location.search === "";
  
  const [tabIndex, setTabIndex] = useState([],() => {
    const localData = localStorage.getItem('tabIndex');
    return localData ? JSON.parse(localData) : [] ;

  });

  const [active, setActive] = useState('1');

  const baseURLL = process.env.BASE_URL;
  const datasetSearchURLL = `${baseURLL}/search`;

  useEffect(() => {
    setTabIndex(JSON.parse(window.localStorage.getItem('tabIndex')));
  }, []);
 

  useEffect(() => {
    window.localStorage.setItem('tabIndex', tabIndex);
  }, [tabIndex]);

 useEffect(() => {
   // Handle the back button
   window.onpopstate = function(event) {
     window.location.href = datasetSearchURLL;
   };
 
   // Clean up the event listener when the component unmounts
   return () => {
     window.onpopstate = null;
   };
 }, [datasetSearchURLL]);



  let   myFunction = function () {
    toggle ? " " : window.location.href = datasetSearchURLL;
  };


  return (
    <Layout path={path} title="Search">
      <div className="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href={`${baseURLL}`}>Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Dataset</li>
          </ol>
        </nav>
        <div className={`dc-page`}>
          <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
            <TabList>
              <Tab onClick={() => { setActive("1"); myFunction() }}><div>WSHFC DATASETS</div></Tab>
              <Tab onClick={() => { setActive("2"); myFunction() }}><div>OTHER DATASETS</div></Tab>
            </TabList>

            <TabPanel>
              <Search
                searchEndpoint={`${process.env.DYNAMIC_API_URL}/search?fulltext=&page=1&page-size=10&publisher__name=Washington%20State%20Housing%20Finance%20Commission&sort=modified&sort_order=desc`}
                // searchEndpoint={`${process.env.DYNAMIC_API_URL}/search`}
	  	 initialSearchState={
                 {'page-size': 25}
               }
                defaultFacets={defaultFacets1}
                sortOptions={sortOptions}
                setSearchUrl={false}
                path={path}
                location={location}
                normalize={normalizeItems}
              >
                <div className="row">
                  <SearchSidebar tab={"1"} />
                  <SearchContent tab={"1"} />
                </div>
              </Search>
            </TabPanel>
            <TabPanel>
              <Search
                searchEndpoint={`${process.env.BACKEND_URL}/api/1/search`}
	  	initialSearchState={
                 {'page-size': 25}
               }
                defaultFacets={defaultFacets}
                sortOptions={sortOptions}
                setSearchUrl={false}
                path={path}
                location={location}
                normalize={normalizeItems}
              >
                <div className="row">
                  <SearchSidebar tab={"2"} />
                  <SearchContent tab={"2"} />
                </div>
              </Search>
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </Layout>
  );
}

export default SearchTemplate;
